import { newAxios } from './index'

export const Req_GetTaskInfo = function(taskId) {
  return newAxios({
    url:`/i/tenant/basic/reptile/task/info`,
    data: {taskId}
  })()
}


//重启报税任务
export const Req_RestartTaxTask = function(data) {
  return newAxios({
    url:`/i/tenant/basic/reptile/task/batch/update/status`,
    data
  },'json')()
}


// WEBPACK FOOTER //
// ./src/request/reptile.js